import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getActiveBulkStep } from '../../../../store/team/selectors';

type TCreateCommissionFooter = {
  handleBack: () => void,
  handleNext: () => void,
  stepsLength: number
  isNextDisabled: boolean
};

const BulkMemberFooter: FC<TCreateCommissionFooter> = ({
  handleBack,
  handleNext,
  stepsLength,
  isNextDisabled,
}) => {
  const { t } = useTranslation(['common', 'commissions', 'tasklists', 'team']);
  const activeStep = useAppSelector(getActiveBulkStep);
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  return (
    <AppBar position="fixed" color="primary" sx={{ top: 'auto', bottom: 0, background: isLight ? 'white' : '' }}>
      <Toolbar sx={{ justifyContent: 'flex-end', mr: 8 }}>
        <Button
          color="primary"
          variant="outlined"
          disabled={activeStep === 0}
          onClick={handleBack}
          startIcon={<ArrowBackIcon />}
          sx={{
            width: 150,
          }}
        >
          {t('back')}
        </Button>
        <Button
          sx={{
            ml: 2,
            width: 200,
          }}
          {...(activeStep !== stepsLength - 1 && {
            endIcon: <ArrowForwardIcon />,
          })}
          color="primary"
          variant="contained"
          onClick={handleNext}
          disabled={isNextDisabled}
        >
          {activeStep === stepsLength - 1 ? t('inviteMembers', { ns: 'team' }) : t('next')}
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export {
  BulkMemberFooter,
};
